import { invoke } from '@tauri-apps/api/core';
import { listen, type UnlistenFn } from '@tauri-apps/api/event';

export interface CapturedKey {
  code: string;
  action: 'down' | 'up';
  repeat: boolean;
}

/** Ligada, o Rust segura todas as teclas (Alt+Tab, tecla Windows...) e as entrega por `keyboard:key`. */
export function keyboardCaptureSet(active: boolean): Promise<void> {
  return invoke('keyboard_capture_set', { active });
}

export function onCapturedKey(handler: (key: CapturedKey) => void): Promise<UnlistenFn> {
  return listen<CapturedKey>('keyboard:key', (e) => handler(e.payload));
}
